<div class="modal-header">
  <h5 class="modal-title">{{ "Follow" | translate }} {{ getDisplayName() }}</h5>
  <button [attr.aria-label]="'Close' | translate" (click)="cancel()" class="btn-close" type="button"></button>
</div>

<div class="modal-body">
  <p class="mb-4">{{ "Which kinds of notifications would you like to receive?" | translate }}</p>

  <div *ngIf="loading" class="text-center py-4">
    <fa-icon animation="spin" icon="spinner"></fa-icon>
  </div>

  <div *ngIf="!loading" class="follow-options">
    <div class="mb-3">
      <astrobin-toggle-button
        [disabled]="saving"
        [label]="'New images' | translate"
        [value]="followImages"
        (toggle)="followImages = $event"
      ></astrobin-toggle-button>
      <small class="d-block text-muted mt-1 ms-5">
        {{ "Get notified when new images are uploaded with this equipment" | translate }}
      </small>
    </div>

    <div class="mb-3">
      <astrobin-toggle-button
        [disabled]="saving"
        [label]="'New forum topics' | translate"
        [value]="followForum"
        (toggle)="followForum = $event"
      ></astrobin-toggle-button>
      <small class="d-block text-muted mt-1 ms-5">
        {{ "Get notified when new forum topics are posted about this equipment" | translate }}
      </small>
    </div>
  </div>

  <div *ngIf="error" class="alert alert-danger mt-3 mb-0">
    {{ error }}
  </div>
</div>

<div class="modal-footer">
  <button [disabled]="saving" (click)="cancel()" class="btn btn-secondary m-0 me-2" type="button">
    {{ "Cancel" | translate }}
  </button>
  <button [disabled]="loading || saving" (click)="save()" class="btn btn-primary m-0" type="button">
    <fa-icon *ngIf="saving" class="me-2" animation="spin" icon="spinner"></fa-icon>
    {{ "Save" | translate }}
  </button>
</div>
